(function() { module.exports = this["wp"]["richText"]; }());